<template>
  <div id="table">
    <single-table :items="blocks.initiator" type="initiators" color="#e85900"></single-table>
    <single-table :items="blocks.monomer" type="monomers" color="#bed6eb"></single-table>
    <single-table :items="blocks.terminator" type="terminators" color="#083b66"></single-table>
  </div>
</template>

<script>
import singleTable from '@/views/Game/BuldingBlocks/Tables/Single';

export default {
  data() {
    return {
      small: true,
    };
  },
  props: ['blocks'],
  components: {
    singleTable,
  },
};
</script>

<style lang="scss" scoped>
@import './src/styles/helpers/_variables.scss';
@import './src/styles/helpers/_include-media.scss';
</style>



// WEBPACK FOOTER //
// src/views/Game/BuldingBlocks/Tables/Index.vue